import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { AppService } from "../services/app.service";
import { FormControl } from "@angular/forms";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/throttleTime";
import "rxjs/add/observable/fromEvent";
import { Subscription } from "rxjs";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import { IMyDpOptions } from "mydatepicker";
import { checkDate as checkDateUtil } from "../utils/format-util";

@Component({
  selector: "app-report-log",
  templateUrl: "./report-log.component.html",
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ReportLogComponent implements OnInit {
  rowsDataPatient = [
    { title: "First Name", sorting: true, name: "patientFirstName" },
    { title: "Last Name", sorting: true, name: "patientLastName" },
    { title: "Mobile Number" },
    { title: "Address", tooltip: true },
    { title: "Email", sorting: true, name: "patientEmail" },
    { title: "Patient Type" },
  ];

  rowsDataPhysician = [
    { title: "First Name", sorting: true, name: "physicianFirstName" },
    { title: "Last Name", sorting: true, name: "physicianLastName" },
    { title: "Mobile Number" },
    { title: "Fax Number" },
    { title: "Address", tooltip: true },
    { title: "Physician Contact" },
    { title: "DPI", sorting: true, name: "physiciandpi" },
    { title: "Tax ID", sorting: true, name: "physiciantaxid" },
    { title: "Patient Type" },
  ];

  rowsDataTech = [
    { title: "First Name" },
    { title: "Last Name" },
    { title: "Year", name: "year" },
    { title: "No of Vacation Days" },
    { title: "No of Personal Days" },
    { title: "No of Sick Days" },
  ];

  columnsData = [];
  columnsDataPhysician = [];
  columnsDataTech = [];
  columnsRes = [];
  p = 1;
  totalItems: any;
  currentPage = 1;
  page: number;
  maxSize = 10;
  maxSizeItem = 10;
  firstNameControl = new FormControl();
  formCtrlSub: Subscription;
  searchPatient = "";
  sortColumn = "";
  orderColumn = "";
  searchText = "";
  alphaVal = "all";
  routerName = "";
  lastyearvalue = 0;
  selectedPatientPrintObject: any;
  physicianPrintListObject: any;
  technicianPrintList: any;
  fromdate: any = "";
  todate: any = "";
  maxSizeItemValue: any;
  tabName = "Patient";
  public myDatePickerOptions1: IMyDpOptions = {};
  public myDatePickerOptions2: IMyDpOptions = {};
  public myDatePickerOptions3: IMyDpOptions = {};
  public myDatePickerOptions4: IMyDpOptions = {};
  currentDate: number;
  currentMonth: number;
  currentYear: number;
  startDatePatient = "";
  startDateObjPatient: any;
  endDatePatient = "";
  startDatePhysician = "";
  startDateObjPhysician: any;
  endDatePhysician = "";
  errorMessage = "";
  date4 = "";
  date3 = "";
  date2 = "";
  date1 = "";
  configOptions: any = {};
  yeardata = [];
  yeardatas = [];
  startyear: any = 2016;
  newdate = new Date();

  constructor(
    private modalService: BsModalService,
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private cd: ChangeDetectorRef
  ) {
    this.myDatePickerOptions1 = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: true,
      inline: false,
    };

    this.myDatePickerOptions2 = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: true,
      inline: false,
    };

    this.myDatePickerOptions3 = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: true,
      inline: false,
    };

    this.myDatePickerOptions4 = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: true,
      inline: false,
    };
  }

  unsub: any;
  ngOnDestroy() {
    this.unsub.unsubscribe();
  }
  ngOnInit() {
    this.configOptions["id"] = "print-sectionpatient";
    this.getPatientList("");
    this.getPatientListPrint();
    this.unsub = this.supportService.gridSortingHeader.subscribe((res) => {
      if (res && res["length"] !== 0 && res["routerName"] === this.routerName) {
        this.sortColumn = res["name"];
        this.orderColumn = res["order"];
        const event = {
          page: 1,
        };
        this.currentPage = 1;
        this.getPatientList(event);
      }
    });

    this.checkUrl();
  }

  getPatientListPrint() {
    const data = {
      pageNumber: 0,
      pageRecord: 0,
      sortColumn: this.sortColumn,
      sortType: this.orderColumn,
      patientType: "all",
      search: this.searchPatient,
      tcId: localStorage.getItem("testCenterId"),
      startDate: this.startDatePatient,
      endDate: this.endDatePatient,
    };

    this.appService.getpatientlistbytcReport(data).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        if (res["entity"]) {
          this.selectedPatientPrintObject = [];
          this.selectedPatientPrintObject = res["entity"];
        }
      }
    });
  }

  checkUrl() {
    const path = this.location.path().split("/");
    if (path.length === 3) {
      this.routerName = path[2];
    }
  }

  getPatientList(event) {
    let data;
    if (event) {
      data = {
        pageNumber: event.page,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        patientType: "all",
        search: this.searchPatient,
        tcId: localStorage.getItem("testCenterId"),
        startDate: this.startDatePatient,
        endDate: this.endDatePatient,
      };
    } else {
      this.currentPage = 1;
      data = {
        pageNumber: 1,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        patientType: "all",
        search: this.searchPatient,
        tcId: localStorage.getItem("testCenterId"),
        startDate: this.startDatePatient,
        endDate: this.endDatePatient,
      };
    }

    this.appService.getpatientlistbytcReport(data).subscribe(
      (res) => {
        this.configOptions["id"] = "print-sectionpatient";
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsData = [];
            this.columnsRes = res["entity"];
            this.columnsRes.forEach((obj) => {
              let address = "";
              if (obj.patientAddressLine1) {
                address += obj.patientAddressLine1 + ", ";
              }
              if (obj.patientAddressLine2) {
                address += obj.patientAddressLine2 + ", ";
              }

              if (obj.patientCityName) {
                address += obj.patientCityName + ", ";
              }

              if (obj.patientStateName) {
                address += obj.patientStateName + ", ";
              }

              if (obj.patientCountryName) {
                address += obj.patientCountryName;
              }
              this.columnsData = this.columnsData.concat({
                param1: obj.patientFirstName ? obj.patientFirstName : "-",
                param2: obj.patientLastName ? obj.patientLastName : "-",
                param3:
                  obj.patientPhone && obj.patientPhoneCode === "+91"
                    ? obj.patientPhoneCode +
                      " " +
                      obj.patientPhone.replace(/^(\d{0,5})(\d{0,5})/, "$1-$2")
                    : obj.patientPhone && obj.patientPhoneCode === "+1"
                    ? obj.patientPhoneCode +
                      " " +
                      obj.patientPhone.replace(
                        /^(\d{0,3})(\d{0,3})(\d{0,4})/,
                        "($1) $2-$3"
                      )
                    : "-",
                param4: address ? address : "-",
                param5: obj.patientEmail !== "null" ? obj.patientEmail : "-",
                param6: obj.patientType
                  ? obj.patientType === "IC"
                    ? obj.patientType
                    : "SchedMed"
                  : "-",
                param12: obj.id ? obj.id : "-",
                param11: obj.patientId ? obj.patientId : "-",
              });
            });
            this.cd.detectChanges();
            this.totalItems = res["count"];
          }
        } else {
          this.columnsData = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  getPhysicianPrintList() {
    const data = {
      pageNumber: 0,
      pageRecord: 0,
      sortColumn: this.sortColumn,
      sortType: this.orderColumn,
      search: this.searchPatient,
      tcId: localStorage.getItem("testCenterId"),
      startDate: this.startDatePhysician,
      endDate: this.endDatePhysician,
    };

    this.appService.getPhysicianListbytcReport(data).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        if (res["entity"]) {
          this.physicianPrintListObject = [];
          this.physicianPrintListObject = res["entity"];
        }
      }
    });
  }

  getPhysicianList(event) {
    this.getPhysicianPrintList();
    let data;
    if (event) {
      data = {
        pageNumber: event.page,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        tcId: localStorage.getItem("testCenterId"),
        startDate: this.startDatePhysician,
        endDate: this.endDatePhysician,
      };
    } else {
      data = {
        pageNumber: 1,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        tcId: localStorage.getItem("testCenterId"),
        startDate: this.startDatePhysician,
        endDate: this.endDatePhysician,
      };
    }

    this.appService.getPhysicianListbytcReport(data).subscribe(
      (res) => {
        this.configOptions["id"] = "print-sectionphysician";
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsDataPhysician = [];
            this.columnsRes = res["entity"];
            this.columnsRes.forEach((obj) => {
              this.columnsDataPhysician = this.columnsDataPhysician.concat({
                param1: obj.physicianFirstName ? obj.physicianFirstName : "-",
                param2: obj.physicianLastName ? obj.physicianLastName : "-",
                param3:
                  obj.physicianPhone && obj.physicianPhoneCode === "+91"
                    ? obj.physicianPhoneCode +
                      " " +
                      obj.physicianPhone.replace(/^(\d{0,5})(\d{0,5})/, "$1-$2")
                    : obj.physicianPhone && obj.physicianPhoneCode === "+1"
                    ? obj.physicianPhoneCode +
                      " " +
                      obj.physicianPhone.replace(
                        /^(\d{0,3})(\d{0,3})(\d{0,4})/,
                        "($1) $2-$3"
                      )
                    : "-",
                param4:
                  obj.physicianFax && obj.physicianFaxCode === "+91"
                    ? obj.physicianFaxCode +
                      " " +
                      obj.physicianFax.replace(/^(\d{0,5})(\d{0,5})/, "$1-$2")
                    : obj.physicianFax && obj.physicianFaxCode === "+1"
                    ? obj.physicianFaxCode +
                      " " +
                      obj.physicianFax.replace(
                        /^(\d{0,3})(\d{0,3})(\d{0,4})/,
                        "($1) $2-$3"
                      )
                    : "-",
                param5:
                  obj.physicianAddressLine1 !== "null"
                    ? obj.physicianAddressLine1
                    : "" + " " + obj.physicianAddressLine2 !== "null"
                    ? obj.physicianAddressLine2
                    : "-",
                param6: obj.physicianContactFirstName
                  ? obj.physicianContactFirstName +
                    " " +
                    obj.physicianContactLastName
                  : "-",
                param7: obj.physiciandpi,
                param8: obj.physiciantaxid,
                param9: obj.patientType
                  ? obj.patientType === "IC"
                    ? obj.patientType
                    : "SchedMed"
                  : "-",
              });
            });
            this.cd.detectChanges();
            this.totalItems = res["count"];
          }
        } else {
          this.columnsDataPhysician = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  getTechPrintList() {
    const data = {
      pageNumber: 0,
      pageRecord: 0,
      tcId: localStorage.getItem("testCenterId"),
      startDate: this.fromdate,
      endDate: this.todate,
    };

    this.appService.getTechLogReport(data).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        if (res["entity"]) {
          this.technicianPrintList = [];
          this.technicianPrintList = res["entity"];
        }
      }
    });
  }

  getalltech(event) {
    if (event) {
      this.fromdate = event + "-01-01";
      this.todate = event + "-12-31";
    } else {
      this.fromdate = this.newdate.getFullYear() + "-01-01";
      this.todate = this.newdate.getFullYear() + "-12-31";
    }
    this.getTechList("");
  }

  getTechList(event) {
    const lastyear = this.newdate.getFullYear();
    this.lastyearvalue = lastyear;
    if (this.yeardatas.length === 0) {
      for (let index = this.startyear; index <= lastyear; index++) {
        this.yeardata.push(index);
      }
      this.yeardatas = this.yeardata.reverse();
    }

    if (this.fromdate === "" || this.todate === "") {
      this.fromdate = this.newdate.getFullYear() + "-01-01";
      this.todate = this.newdate.getFullYear() + "-12-31";
    }

    this.getTechPrintList();
    let data;
    if (event) {
      data = {
        pageNumber: event.page,
        pageRecord: this.maxSizeItem,
        tcId: localStorage.getItem("testCenterId"),
        startDate: this.fromdate,
        endDate: this.todate,
      };
    } else {
      this.currentPage = 1;
      data = {
        pageNumber: this.currentPage,
        pageRecord: this.maxSizeItem,
        tcId: localStorage.getItem("testCenterId"),
        startDate: this.fromdate,
        endDate: this.todate,
      };
    }

    this.appService.getTechLogReport(data).subscribe(
      (res) => {
        this.configOptions["id"] = "print-sectiontech";
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsDataTech = [];
            this.columnsRes = res["entity"];
            this.columnsRes.forEach((obj) => {
              this.columnsDataTech = this.columnsDataTech.concat({
                param1: obj.firstName ? obj.firstName : "-",
                param2: obj.lastName ? obj.lastName : "-",
                param3: obj.year ? obj.year : "-",
                param4: obj.vacationDaysLeft ? obj.vacationDaysLeft : "-",
                param5: obj.personalDaysLeft ? obj.personalDaysLeft : "-",
                param6: obj.sickDaysLeft ? obj.sickDaysLeft : "-",
              });
            });
            this.cd.detectChanges();
            this.totalItems = res["count"];
          }
        } else {
          this.columnsDataTech = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  pagePatientChanged(event: any): void {
    if (this.tabName === "Patient") {
      this.page = event.page;
      this.getPatientList(event);
    }
  }

  pagePhysicianChanged(event: any): void {
    if (this.tabName === "Physician") {
      this.page = event.page;
      this.getPhysicianList(event);
    }
  }

  pageTechChanged(event: any): void {
    if (this.tabName === "Technician") {
      this.page = event.page;
      this.getTechList(event);
    }
  }

  onDateChanged1(event) {
    this.startDatePatient =
      event.date.year +
      "-" +
      this.checkDate(event.date.month) +
      "-" +
      this.checkDate(event.date.day);

    const today = new Date(event.jsdate);
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);

    this.startDateObjPatient = {
      day: this.checkDate(yesterday.getDate()),
      month: this.checkDate(yesterday.getMonth() + 1),
      year: yesterday.getFullYear(),
    };

    this.myDatePickerOptions2 = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: true,
      inline: false,
      disableUntil: this.startDateObjPatient,
    };

    this.date2 = "";
    this.endDatePatient = "";
  }

  onDateChanged2(event) {
    this.endDatePatient =
      event.date.year +
      "-" +
      this.checkDate(event.date.month) +
      "-" +
      this.checkDate(event.date.day);
  }

  onDateChanged3(event) {
    this.startDatePhysician =
      event.date.year +
      "-" +
      this.checkDate(event.date.month) +
      "-" +
      this.checkDate(event.date.day);
    const today = new Date(event.jsdate);
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);

    this.startDateObjPhysician = {
      day: this.checkDate(yesterday.getDate()),
      month: this.checkDate(yesterday.getMonth() + 1),
      year: yesterday.getFullYear(),
    };

    this.myDatePickerOptions4 = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: true,
      inline: false,
      disableUntil: this.startDateObjPhysician,
    };

    this.date4 = "";
    this.endDatePhysician = "";
  }

  onDateChanged4(event) {
    this.endDatePhysician =
      event.date.year +
      "-" +
      this.checkDate(event.date.month) +
      "-" +
      this.checkDate(event.date.day);
  }

  checkDate(str) {
    return checkDateUtil(str);
  }

  savePatientPdf() {
    const data = {
      pageNumber: 0,
      pageRecord: 0,
      sortColumn: this.sortColumn,
      sortType: this.orderColumn,
      patientType: "all",
      search: this.searchPatient,
      tcId: localStorage.getItem("testCenterId"),
      startDate: this.startDatePatient,
      endDate: this.endDatePatient,
      type: "patientlog",
    };

    this.downloadAndSavePdf(data);
  }

  private downloadAndSavePdf(data) {
    this.appService.downloadPatientLogPdf(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"] && res["entity"]["pdfFileURL"]) {
            this.appService.savePdf(res["entity"]["pdfFileURL"]);
          }
        } else {
          this.errorMessage = "Data not found";
          setTimeout(() => {
            this.errorMessage = "";
          }, 5000);
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  savePhysicianPdf() {
    const data = {
      pageNumber: 0,
      pageRecord: 0,
      sortColumn: this.sortColumn,
      sortType: this.orderColumn,
      patientType: "all",
      search: this.searchPatient,
      tcId: localStorage.getItem("testCenterId"),
      startDate: this.startDatePhysician,
      endDate: this.endDatePhysician,
      type: "physicianlog",
    };

    this.downloadAndSavePdf(data);
  }

  saveTechPdf() {
    const data = {
      pageNumber: 0,
      pageRecord: 0,
      sortColumn: "",
      sortType: "",
      patientType: "",
      search: this.searchPatient,
      tcId: localStorage.getItem("testCenterId"),
      startDate: "",
      endDate: "",
      type: "technicianlog",
    };

    this.downloadAndSavePdf(data);
  }

  generatePatientList() {
    if (this.startDatePatient && this.endDatePatient) {
      this.getPatientList("");
      this.getPatientListPrint();
    } else {
      this.errorMessage = "Please select From and To dates";
      setTimeout(() => {
        this.errorMessage = "";
      }, 5000);
    }
  }

  generatePhysicianList() {
    if (this.startDatePhysician && this.endDatePhysician) {
      this.getPhysicianList("");
    } else {
      this.errorMessage = "Please select From and To dates";
      setTimeout(() => {
        this.errorMessage = "";
      }, 5000);
    }
  }

  refreshPatient() {
    this.date1 = "";
    this.date2 = "";
    this.startDatePatient = "";
    this.endDatePatient = "";
    this.getPatientList("");
    this.getPatientListPrint();
  }

  refreshPhysician() {
    this.date3 = "";
    this.date4 = "";
    this.startDatePhysician = "";
    this.endDatePhysician = "";
    this.getPhysicianList("");
  }
}
